// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "form.guest-name-dialog[data-v-0eec23a0] {\n  display: flex;\n  max-width: 200px;\n  margin: auto;\n  margin-top: -2px;\n  padding: 3px;\n}\nform.guest-name-dialog[data-v-0eec23a0] img {\n    margin: 0 !important;\n}\nform.guest-name-dialog input[type=text][data-v-0eec23a0] {\n    flex-grow: 1;\n}\nform.guest-name-dialog label[data-v-0eec23a0] {\n    padding: 3px;\n    height: 32px;\n}\n", ""]);
// Exports
module.exports = exports;
